<template>
    <div class="rezultati-card" :class="{ 'invalid': !userAnswer.correct }">
        <i class="tag">{{ type }}</i>
        <div class="check"></div>

        <p class="question" v-html="questionHtml"></p>

        <img class="img" v-if="userAnswer && userAnswer.image" :src="userAnswer.image" alt="Question image"/>

        <template v-if="userAnswer.answer">
            <p class="answer" v-html="answerHtml"></p>
            <img class="answer-img" v-if="userAnswer && userAnswer.answerImgValue" :src="userAnswer.answerImgValue" alt="Answer image"/>
            <template v-if="!userAnswer.correct">
                <p class="answer">Točan odgovor: {{ correctAnswer.value }}</p>
                <img class="answer-img" v-if="correctAnswer && correctAnswer.imgValue" :src="correctAnswer.imgValue" alt="Answer image"/>
            </template>
            <p class="info">
                <span v-if="userAnswer.correct">Točan odgovor</span>
                <span v-if="!userAnswer.correct">Netočan odgovor</span>
                <span><i>{{ points }}</i> bodova</span>
                <span>Bodovi za vrijeme: <i>{{ userAnswer.correct ? userAnswer.timeLeft : 0 }}</i></span>
            </p>
        </template>
        <template v-if="!userAnswer.answer">
            <p class="answer">Nisi odgovorio/la na ovo pitanje</p>
                <p class="answer">Točan odgovor: {{ correctAnswer.value }}</p>
                <img class="answer-img" v-if="correctAnswer && correctAnswer.imgValue" :src="correctAnswer.imgValue" alt="Answer image"/>
        </template>
    </div>
</template>

<script>

import { QuestionUtils } from '../utils/questionUtils'

export default {
    name: 'rezultati-single-card',
    data: function () {
        return {
        }
    },
    props: {
        userAnswer: Object,
        questionId: Number,
        correctAnswer: Object
    },
    computed: {
        points () {
            if (this.userAnswer.hasOwnProperty('points')) {
                return this.userAnswer.points
            }
            return 0
        },
        type () {
            return QuestionUtils.getTypeText(this.userAnswer.type)
        },
        answerHtml () {
            try {
                if (this.userAnswer && this.userAnswer.answerValue) {
                    return `${this.userAnswer.answer}. ${this.userAnswer.answerValue}`
                }
            } catch (error) {
                console.error(error)
            }
            return ''
        },
        questionHtml () {
            try {
                if (this.userAnswer && this.userAnswer.question) {
                    return `<span>${this.questionId}.</span>${this.userAnswer.question}`
                }
            } catch (error) {
                console.error(error)
            }
            return ''
        }
    }
}
</script>

<style lang="scss" scoped>
.rezultati-card {
    display: block;
    position: relative;
    box-shadow: -2px 22px 24px 0px rgba(0, 0, 0, 0.07);
    background-color: #fff;
    padding: 40px 13px 8px 13px;
    border-radius: 5px;
    margin-bottom: 30px;
    text-align: left;

    > i {
        display: inline-block;
        position: absolute;
        left: 13px;
        top: 9px;
        box-shadow: 0px 4px 40px 0px rgba(255, 0, 29, 0.33);
        background: linear-gradient(135deg, #ff0084 0%, #ff0084 42%, #ff001d 100%);
        font-family: "axiforma";
        font-weight: 800;
        letter-spacing: 1px;
        font-size: 10px;
        color: #fff;
        text-transform: uppercase;
        line-height: 19px;
        padding: 0 8px;
        border-radius: 6px;
    }
    .check {
        display: block;
        position: absolute;
        top: 9px;
        right: 10px;
        width: 20px;
        height: 20px;
        background-color: #3d85cd;
        border-radius: 8px;
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: 12px;
        background-image: url(~@/assets/img/icons/check.png);
    }
    .question {
        font-family: "mPlus";
        color: #000;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: -.2px;
        font-weight: 800;
        margin-bottom: 30px;

        span {color: #3d85ce;}
    }
    .answer {
        font-family: "mPlus";
        color: #000;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: -.2px;
        font-weight: 800;
        margin-bottom: 20px;
    }
    .info {
        font-family: "axiforma";
        font-size: 11px;
        font-weight: 700;
        color: #c3c3c4;
        margin: 0;

        span:not(:last-child) {
            display: inline-block;
            border-right: 2px solid #000;
            padding-right: 4px;
            margin-right: 4px;
        }
    }
    .img {
        height: auto;
        width: auto;
        max-width: 100%;
    }
}
.rezultati-card.invalid {
    .check {
        background-color: #ff0021;
        background-image: url(~@/assets/img/icons/icon-close-4.png);
        background-size: 9px;
    }
}
</style>
